import { CancelToken } from "axios";
import { DeliveryApi } from "@/api/delivery.api";
import { PartnerPickupPromise } from "@/types/partner-pickup-promise.interface";

export class PartnerPickupApi extends DeliveryApi {
  calculateDelivery(
    saleId: number,
    cancelToken?: CancelToken
  ): Promise<PartnerPickupPromise> {
    return this.axios
      .post<{ promise: PartnerPickupPromise }>(
        "/delivery/partnerPickup/promise",
        { saleId },
        { cancelToken }
      )
      .then((r) => r.data.promise);
  }
}
